/**
 * Nível de apreciação de um gestor (NIV-01..05), calculado SÓ pelo `cod_etapa`.
 *
 * Regra redefinida em 2026-10-21 (Evolução PM 6ace7452): o `cod_etapa_sub` indica que o
 * funcionário está substituindo um gestor de outro nível, mas ele continua apreciando o
 * próprio time pelo nível oficial. O sub serve apenas para a busca lateral
 * (`get_gestor_prefixo`): é por lá que o substituto chega ao gestor que substitui e
 * aprecia no lugar dele. Antes (NIV-04, `ea64d0e7`) o sub vencia quando era maior, e um
 * Nível 1 com sub 4 virava Nível 2 no próprio time: a promoção não concluía as demais
 * bonificadas nem gravava o avaliador do Nível 2.
 *
 * Mora em `utils` porque a mesma conta vivia em quatro lugares (contexto Normal, contexto
 * MAD e os dois cards de realização) e cada cópia precisou de um commit próprio na última
 * mudança de regra.
 *
 * Contratos preservados:
 * - normalização só para COMPARAR: 1 vale 3 (Gerente de Soluções segue as regras do
 *   Nível 1), acima de 5 vale 0 (99 é sentinela da base);
 * - com `comporDupla`, o maior `cod_etapa` normalizado dos parceiros da `mad_dupla` vence
 *   se for estritamente maior que o próprio normalizado (NIV-02);
 * - quando o próprio vence, o retorno é CRU (cod_etapa 1 retorna 1, 99 retorna 99): os
 *   call-sites testam `=== 1 || === 3` (NIV-05).
 */
export interface NivelApreciacaoOpcoes {
  /** Compõe o nível pela dupla de liderança (`mad_dupla`). */
  comporDupla?: boolean;
}

export function normalizaNivel(valor: unknown): number {
  if (typeof valor !== 'number') return 0;

  if (valor === 1) return 3;

  return valor > 5 ? 0 : valor;
}

export function nivelApreciacao(user: any, { comporDupla = false }: NivelApreciacaoOpcoes = {}): number | undefined {
  if (!user) return undefined;

  const proprio = typeof user.cod_etapa === 'number' ? user.cod_etapa : 0;

  const maiorDaDupla =
    comporDupla && Array.isArray(user.mad_dupla)
      ? Math.max(0, ...user.mad_dupla.map((parceiro: any) => normalizaNivel(parceiro?.cod_etapa)))
      : 0;

  return maiorDaDupla > normalizaNivel(proprio) ? maiorDaDupla : proprio;
}
